package com.tregz.tremenz.ui.component

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.tregz.tremenz.io.model.ModelStatus
import com.tregz.tremenz.ui.label.LabelKey
import com.tregz.tremenz.ui.label.labelText

/**
 * What a catalogue tab shows in place of its list while there is nothing to list: a spinner while
 * the source loads, a message with a retry when it failed, and an empty note when it answered with
 * nothing. Without it all three look the same, a blank screen.
 */
@Composable
fun StatusNotice(
    status: ModelStatus,
    onRetry: () -> Unit,
    modifier: Modifier = Modifier
) {
    val scheme = MaterialTheme.colorScheme
    Card(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 6.dp),
        colors = CardDefaults.cardColors(containerColor = scheme.surface),
        shape = MaterialTheme.shapes.medium
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(24.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            if (status == ModelStatus.LOADING) {
                CircularProgressIndicator(
                    color = scheme.primary,
                    modifier = Modifier.size(28.dp),
                    strokeWidth = 3.dp
                )
            }
            Text(
                text = labelText(
                    when (status) {
                        ModelStatus.LOADING -> LabelKey.STATUS_LOADING
                        ModelStatus.FAILED -> LabelKey.STATUS_FAILED
                        ModelStatus.LOADED -> LabelKey.STATUS_EMPTY
                    }
                ),
                color = scheme.onSurfaceVariant,
                style = MaterialTheme.typography.bodyMedium
            )
            if (status == ModelStatus.FAILED) {
                TextButton(onClick = onRetry) {
                    Text(labelText(LabelKey.ACTION_RETRY))
                }
            }
        }
    }
}
